import React from 'react';
import { get, isEqual } from 'lodash';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import {
    fetchChannelCallouts
} from 'services/channel/duck';

import { getDefaultChannelDataSources } from 'helpers/channels';

import RenderingTile from 'components/molecules/RenderingTile';
import DashboardBaseComponent from 'containers/dashboards/DashboardBaseComponent';
import ChannelSummaryCallout from 'components/molecules/ChannelSummaryCallout';
import { SideBarObjects } from 'components/pages/config/DashboardSideBarObjects';

class ChannelSummaryCalloutContainer extends DashboardBaseComponent {
    constructor(props) {
        super(props, props.channel);
    }

    makeRequestsForData() {
        const entityId = this.getCurrentEntityId();
        const channel = this.getCurrentChannel();
        const payload = this.createPayload(entityId, channel);

        this.props.fetchChannelCallouts(payload);
    }

    shouldComponentUpdate(nextProps) {
        const channel = this.getCurrentChannel();

        const nextCallouts = nextProps.channelMap[channel].callouts;
        const currentCallouts = this.props.channelMap[channel].callouts;

        return !isEqual(nextCallouts, currentCallouts) ||
            !isEqual(nextProps.entityId, this.props.entityId) ||
            !isEqual(nextProps.entityObjective, this.props.entityObjective);
    }

    render() {
        const entityId = this.getCurrentEntityId();
        const channel = this.getCurrentChannel();
        const callouts = this.props.channelMap[channel].callouts;
        const sideBarChannel = SideBarObjects.find(menu => menu.channel === channel);
        const hasData = callouts && callouts.params.hasData;

        const defaultChannelPlatform = getDefaultChannelDataSources(this.props.entityPlatform)[channel];
        const channelPlatform = get(this.props.channelDataSources, channel, defaultChannelPlatform);

        return (
            hasData ? (
                <ChannelSummaryCallout
                    exportName={this.props.exportName}
                    channel={sideBarChannel}
                    disableDiveInLink={this.props.enforceSummaryOnlyDashboardView}
                    callouts={callouts}
                    entityId={entityId}
                    entityObjective={this.props.entityObjective}
                    entityObjectiveLabelCode={this.props.entityObjectiveLabelCode}
                    channelPlatform={channelPlatform}
                    channelOptions={this.props.channelOptions}
                />) : (
                <RenderingTile height='80px' />
            )
        );
    }
}

const mapStateToProps = state => ({
    channelMap: state.channel,
    currentUser: state.users.currentUser,
    selectedTimeRange: state.config.selectedTimeRange,
    channelDataSources: get(state, 'entities.meta.channelDataSources', {}),
    entityPlatform: get(state, 'entities.meta.entityPlatform', 'ccms'),
    entityObjective: get(state, 'entities.meta.meta.programmaticObjective.global', 'ecpa'),
    enforceSummaryOnlyDashboardView: get(state, 'entities.meta.meta.enforceSummaryOnlyDashboardView', false),
    entityObjectiveLabelCode: get(state, 'entities.meta.meta.programmaticObjective.labelCode', null),
});

export default connect(mapStateToProps, {
    fetchChannelCallouts,
    push
})(ChannelSummaryCalloutContainer);



// WEBPACK FOOTER //
// ./src/containers/callouts/ChannelSummaryCalloutContainer.js